import type { PaymentMethod } from '@backmarket/http-api/src/api-specs-payment/payment/payment.types'
import type { I18n } from '@backmarket/nuxt-module-i18n/types/i18n'

import { paymentMethodName } from '../../../methods/helpers/methods'
import { isPaymentNetworkError } from '../../helpers/isPaymentNetworkError'
import type { PaymentSetupError } from '../../types/PaymentSetupError'

import translations from './PaymentMethodFormBase.translations'

export const getSetupErrorMessage = (
  i18n: I18n,
  method: PaymentMethod | null,
  error: PaymentSetupError,
) => {
  const values = {
    paymentMethod: method?.bmCode ? paymentMethodName(method.bmCode) : '',
  }

  if (error.readableMessage) {
    return error.readableMessage
  }

  if (isPaymentNetworkError(error)) {
    return {
      title: i18n(translations.defaultSetupErrorTitle, values),
      description: i18n(translations.genericNetworkErrorDescription),
    }
  }

  return {
    title: i18n(translations.defaultSetupErrorTitle, values),
    description: i18n(translations.defaultSetupErrorDescription, {
      ...values,
      reason: error.message || `${error}`,
    }),
  }
}
